export const raceWeekData = [
  {
    id: "treasure_33",
    name: "The Squire's Landing",
    hint: "Find the bustling harbor spot where ships sail and stories unfold \u2014 seek the T5 building at Circular Quay West, and your prize awaits.\n",
    offer: "10% off food and beverage",
    address: "T5 Circular Quay West, The Rocks, Sydney 2000",
    hours: "12:00pm - Late everyday",
    redeem:
      "Input the unique redemption code when ordering online via 'The Pass' app.",
    terms:
      "Offer valid only at The Squire's Landing during race week. Not valid in conjunction with any other offer. One redemption per customer. Subject to availability.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.8574223615663,
      longitude: 151.21016870831113,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FThe%20Squire's%20%20Landing.jpg?alt=media&token=f2496897-555d-4b02-8628-bb9c78a3af41",
  },
  {
    id: "treasure_34",
    name: "Ventuno",
    hint: "Wood-fired aromas  and the slow swirl of la dolce vita in every bite.",
    offer: "$39 \nEnjoy one of our wood-fired pizzas and a wine or beer.\n",
    address: "7/21 Hickson Road, Walsh Bay, Sydney 2000",
    hours:
      "Mon \u2013 Tues: 12:00pm \u2013 3:00pm, 5:00pm \u2013 9:00pm\nWed: 11:30am \u2013 3:00pm, 5:30pm \u2013 9:30pm\nThurs \u2013 Fri: 12:00pm \u2013 3:00pm, 5:30pm \u2013 9:30pm\nSat: 11:30am \u2013 9:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Choice of wine or beer is limited to selected options determined by the venue. Not valid in conjunction with any other offer. Available only during race week.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85677016955708,
      longitude: 151.20428369079923,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FVentuno.jpg?alt=media&token=6fd3e2fa-e5c7-4f51-b192-2ab01055a02c",
  },
  {
    id: "treasure_35",
    name: "Three Blue Ducks Rosebery",
    hint: "Make your way to 1/85 Dunning Avenue, Rosebery, for a fresh and rustic dining experience in a converted warehouse setting.",
    offer:
      "Enjoy a free drink on \u2018The Ducks\u2019 with every meal purchased!",
    address: "1/85 Dunning Avenue, Rosebery, NSW 2018",
    hours:
      "Tuesday \u2013 Thursday: 12:00pm \u2013 9:00pm\nFriday: 6:30am \u2013 9:00pm\nSaturday: 8:30am \u2013 9:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.916837117123336,
      longitude: 151.2023097836492,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FThree%20Blue%20%20Ducks%20Rosebery.jpg?alt=media&token=4dcfafa9-49ed-497f-8199-09f5cbdd8c2a",
  },
  {
    id: "treasure_36",
    name: "Chateau Tanunda Sydney Cellar Door",
    hint: "Find your way to Nurses Walk in The Rocks for 2-for-1 tastings of Barossa’s finest wines at Sydneys Cellar Door",
    offer:
      "2-for-1 pricing on all tasting offerings at the Sydney Cellar Door.",
    address: "2 Nurses Walk, The Rocks",
    hours:
      "Tuesday \u2013 Friday: 1:00pm \u2013 8:00pm\nSaturday: 12:00pm \u2013 8:00pm",
    redeem:
      "Guests can verbally tell the staff on arrival of the code to access the 2 for 1 offer",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85956605309834,
      longitude: 151.20836859677092,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FChateau%20Tanunda%20Sydney%20Cellar%20Door.jpg?alt=media&token=7f4574a2-8d91-441b-ba25-ad170e4c478c",
  },
  {
    id: "treasure_37",
    name: "Arthouse Kitchen",
    hint: "Stop by Greens Road, Paddington, and enjoy 20% off your meal at this cozy, Arthouse spot.",
    offer: "20% off",
    address: "1 Greens Road, Paddington, NSW 2021",
    hours:
      "Monday \u2013 Friday: 7:00am \u2013 4:00pm\nSaturday: 7:00am \u2013 3:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.883581714417446,
      longitude: 151.2206469499425,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FArthouse%20Kitchen.jpg?alt=media&token=41f3838d-cd23-4dcb-8457-69d7811fc754",
  },
  {
    id: "treasure_38",
    name: "South Dowling Sandwiches Darlinghurts",
    hint: "Fuel up on South Dowling Street, Darlinghurst, with the exclusive TCS Sydney Marathon Sandwich and an electrolyte drink.\n",
    offer: "The TCS Sydney Marathon Sandwich + electrolyte drink.",
    address: "377 South Dowling Street, Darlinghurst 2010",
    hours:
      "Tuesday 26th \u2013 Saturday 30th, and Monday 1st\nFrom: 8:00am \u2013 3:15pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Any add ons to sandwich or order will be an additional charge. No substitutions.\n Available in store only.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88313647174886,
      longitude: 151.21840368425097,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FSouth%20Dowling%20Sandwiches%20Darlinghurts.jpg?alt=media&token=1603994e-4203-47ba-bbf8-90cb14a049ea",
  },
  {
    id: "treasure_39",
    name: "South Dowling Sandwiches Kent St",
    hint: "Find your energy boost on Kent Street, Millers Point, with the exclusive TCS Sydney Marathon Sandwich paired with an electrolyte drink.\n\n",
    offer: "The TCS Sydney Marathon Sandwich + electrolyte drink.",
    address: "110 Kent Street, Millers Point 2000",
    hours:
      "Tuesday 26th \u2013 Friday 29th, and Monday 1st\nFrom: 7:30am \u2013 3:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Any add ons to sandwich or order will be an additional charge. No substitutions.\n Available in store only.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86102067456217,
      longitude: 151.20392788214411,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FSouth%20Dowling%20Sandwiches%20Kent%20St.jpg?alt=media&token=d5194745-96c4-4aaa-a941-12d57fcc8a07",
  },
  {
    id: "treasure_40",
    name: "XOPP by Golden Century",
    hint: "Step into Haymarket’s Little Pier Street for seafood delights—mention the Sydney Marathon for 10% off at XOPP.",
    offer: "10% off",
    address: "Level M, 1 Little Pier Street, Haymarket, NSW 2000",
    hours:
      "Lunch: 12:00pm \u2013 3:00pm\nDinner: 5:30pm \u2013 10:00pm\n(Extended to 11:00pm on Friday and Saturday)",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.877938939172985,
      longitude: 151.2022114762533,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FXOPP%20by%20Golden%20Century.jpg?alt=media&token=3adcfc82-fc3f-4bcb-b705-2a53dfa45536",
  },
  {
    id: "treasure_41",
    name: "Harajuku Gyoza Beer Stadium",
    hint: "Head to Darling Drive for tasty rice bowls paired with a drink \u2014 all for $25 to keep your energy up.",
    offer: "$25 \nRice bowl and a drink (tap beer, house wine, or soft drink).",
    address: "1/14 Darling Drive, Sydney 2000",
    hours: "11:30am \u2013 9:00pm everyday",
    redeem: "Must show code to staff/server to redeem",
    terms: "Code valid only for this specific offer",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.87686485911841,
      longitude: 151.20131983322366,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FHarajuku%20Gyoza%20Beer%20Stadium.jpg?alt=media&token=32e90d7f-0c2c-4d03-9675-868bbed56e8f",
  },
  {
    id: "treasure_42",
    name: "Mecca Coffee",
    hint: "Fuel your Paddington morning at Glenmore Road with a buy-two-get-one-free coffee deal—or grab beans and get a free brew at Mecca.",
    offer:
      "Buy two coffees, get one free.\nBuy a bag of beans, receive a free coffee.",
    address: "Shop 4, 2\u201316 Glenmore Road, Paddington",
    hours: "7:00am \u2013 4:00pm (every day)",
    redeem: "Must show code or app to server",
    terms: "Limited to coffee only, i.e. not matcha or chai",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88351572892155,
      longitude: 151.2223730022922,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FMecca%20Coffee.jpg?alt=media&token=361bca4b-012b-4574-be8b-ed7715dfcb3b",
  },
  {
    id: "treasure_43",
    name: "Simon Says Juice",
    hint: "Did someone say Simon? Drop by 263 Oxford Street, Darlinghurst, for your post-run fuel—think fresh juices, nourishing bowls, and laid-back community vibes. ",
    offer:
      "Runners get 30% off all meals for the week leading up to the event. Medal Monday: Complimentary coffee when you show your finisher medal.",
    address: "263 Oxford Street, Darlinghurst, Sydney, 2010",
    hours: "Monday \u2013 Friday: 6:30am \u2013 3:00pm",
    redeem:
      "Must show code & proof of marathon participation to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88166120118039,
      longitude: 151.21887599236814,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FSimon%20Says%20Juice.jpg?alt=media&token=4b3f21b3-55e4-479c-8fb3-d20e154e634d",
  },
  {
    id: "treasure_44",
    name: "Joe Bananas",
    hint: "Find stylish shirts, trousers, and jackets on George Street at The Rocks \u2014 enjoy 20% off for the marathon community.",
    offer:
      "20% off on shirts, trousers, and jackets for the TCS Sydney Marathon community.",
    address: "103 George Street, The Rocks",
    hours: "Tuesday \u2013 Saturday: 10:00am \u2013 6:00pm",
    redeem:
      "Must show code to staff/server to redeem or enter the code when shopping online",
    terms: "Code valid only for this specific offer",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.87224333261458,
      longitude: 151.20652926316046,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FJoe%20Bananas.jpg?alt=media&token=2fb36b13-7a32-4b2d-a067-cd69272bf189",
  },
  {
    id: "treasure_45",
    name: "Playfair Restraunt, Sydney Harbour Hotel",
    hint: "Fuel up for race day on George Street, The Rocks, with carb-loading pasta and pizza specials, plus a fresh juice station breakfast. You'll find it inside Sydney Harbour Hotel.",
    offer:
      "- Pre-Race Carb-Loading Dinner : Pasta & pizza specials available on\u00a0Saturday, 30th August from 5:00pm \u2013 9:00pm\n\n- Recovery Juice Station : A selection of juices designed for post-race recovery, immunity, and hydration. Available on\u00a0Monday, 1st September from 7:00am \u2013 10:00am.",
    address: "55 George Street, The Rocks",
    hours: "Saturday: 5pm - 9pm\n Monday: 7am - 10am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.8581017819296,
      longitude: 151.20876766206257,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FPlayfair%20Restraunt%2C%20Sydney%20Harbour%20Hotel.jpg?alt=media&token=a7074621-9f8d-4cbd-a3c0-b23396fcb663",
  },
  {
    id: "treasure_46",
    name: "Old Mates Deli",
    hint: "Stop by Oxford Street, Woollahra, and enjoy 15% off at this local deli \u2014 perfect for a tasty grab-and-go.\n",
    offer: "15% off",
    address: "36 Oxford Street, Woollahra, NSW 2025",
    hours:
      "Monday \u2013 Friday: 6:30am \u2013 2:30pm\nSaturday: 7:30am \u2013 2:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.88893682574869,
      longitude: 151.23269209269466,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FOld%20Mates%20Deli.jpg?alt=media&token=d772b1d2-0f98-43c9-9939-7b039f9f09b4",
  },
  {
    id: "treasure_47",
    name: "Paddington Grind",
    hint: "Swing by Oxford Street, Paddington, for coffee deals and free water or a small coffee with your sandwich.\n",
    offer:
      "Buy 2 coffees, get 1 bottle of water free.\nBuy a sandwich, get a small coffee free.",
    address: "Shop 2, 339 Oxford Street, Paddington, NSW 2021",
    hours:
      "Monday \u2013 Friday: 5:15am \u2013 3:00pm\nSaturday: 5:15am \u2013 3:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.885949749551905,
      longitude: 151.22856082970796,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FPaddington%20Grind.jpg?alt=media&token=a9b6e6b0-8de6-4518-8e2a-6f5cde81dea7",
  },
  {
    id: "treasure_48",
    name: "Endeavour Tap Rooms",
    hint: "Head to 39-43 Argyle Street, The Rocks, and step into a heritage-style venue pouring small-batch brews in a laid-back setting. Look out for 'tap'",
    offer:
      "Daily $29 meal specials, Happy Hour 4 - 6 pm. Buy a tasting paddle, get another free!",
    address: "39\u201343 Argyle Street, The Rocks, NSW 2000",
    hours:
      "Monday \u2013 Thursday: 12:00pm \u2013 10:00pm\nFriday \u2013 Saturday: 11:30am \u2013 12:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85925815561244,
      longitude: 151.20811402238886,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FEndeavour%20%20Tap%20Rooms.jpg?alt=media&token=56a31d22-1d62-45c1-9e53-ce242762b152",
  },
  {
    id: "treasure_49",
    name: "The Australian Heritage Hotel",
    hint: "Head to Cumberland Street, The Rocks, for a $25 pizza and beer deal—perfect post-run fuel in an old aussie hotel.",
    offer:
      "Tuesday 26th \u2013 Friday 29th & Monday 1st Sept\n$7 Happy Hour, 4:00pm \u2013 6:00pm\n\nSaturday 30th\n$15 House Cocktails between 9:00pm \u2013 11:00pm\n\nTuesday 26th \u2013 Monday 1st Sep\n$25 Pizza & Beer Deal\n\nMonday 1st Sept \n$15 Pizza & $12 Cocktails \n(T&Cs: Cocktails limited to Margaritas)\n\nTuesday 26th \n$1 Wings \n(T&Cs: Minimum order of 5)",
    address: "100 Cumberland Street, The Rocks, NSW 2000",
    hours: "11:00am \u2013 12:00am (every day)",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.859638210732534,
      longitude: 151.2069663794033,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FThe%20Australian%20Heritage%20Hotel.jpg?alt=media&token=849b8f67-ce62-4aab-ad7c-6dd3f6a22dab",
  },
  {
    id: "treasure_50",
    name: "Barrelhouse Cellars",
    hint: "Discover George Street, The Rocks, and enjoy free wine and spirit tastings for the marathon community. Look out for the Cellars",
    offer: "Free wine and spirit tasting for the Marathon community.",
    address: "73 George Street, The Rocks, Sydney",
    hours:
      "Monday \u2013 Thursday: 10:00am \u2013 7:00pm\nFriday \u2013 Saturday: 10:00am \u2013 8:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85856350212335,
      longitude: 151.20890975022243,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FBarrelhouse%20Cellars.jpg?alt=media&token=f79cc937-798e-42f8-a418-8738c41942aa",
  },
  {
    id: "treasure_51",
    name: "Black&White Espresso The Rocks",
    hint: "Fuel your run on George Street, The Rocks, with 10% off coffee and grab the signature Sydney Marathon Cookie for $12.\n",
    offer:
      "10% off coffee for marathon runners.\nCoffee & signature Sydney Marathon cookie for only $12.",
    address: "140 George Street, The Rocks, NSW 2000",
    hours: "7:00am \u2013 3:00pm (Daily)",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.859916130844695,
      longitude: 151.20884687771922,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FBlack%26White%20Espresso%20The%20Rocks.jpg?alt=media&token=94b4ba65-9e27-4243-9f36-471dc36abcc1",
  },
  {
    id: "treasure_52",
    name: "Black&White Espresso The Strand",
    hint: "Grab your marathon fuel at George Street’s The Strand — coffee’s 10% off and the signature Sydney Marathon Cookie just $12 from Black & White.",
    offer:
      "10% off coffee for marathon runners.\nCoffee & signature Sydney Marathon cookie for only $12.",
    address: "G18/412\u2013414 George Street, Sydney, NSW 2000",
    hours: "8:00am \u2013 5:00pm (Daily)",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.869382052795984,
      longitude: 151.2078983814648,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FBlack%26White%20Espresso%20The%20Strand.jpg?alt=media&token=1da99b5a-8023-435b-ab5e-59d07587db55",
  },
  {
    id: "treasure_53",
    name: "The Sauna Project Sydney",
    hint: "After the race, unwind with a sauna near Vaucluse Beach with 25% off, perfect for runners, supporters, and spectators.",
    offer: "25% off for all runners, spectators, and support crew.",
    address: "Vaucluse Beach Paddock, Wentworth Road, Vaucluse",
    hours: "Thursday \u2013 Saturday: All day\nMonday, 1st September: All day",
    redeem:
      "Use the code TCSSYDMARA25 at checkout when booking through our website https://www.thesaunaproject.com.au/sydney",
    terms:
      "This offer is valid for single use only per email address. Not applicable to voucher purchases or multi-pass packs.",
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.85343900881392,
      longitude: 151.2735030581763,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FThe%20Sauna%20Project%20Sydney.jpg?alt=media&token=16ac67bb-e518-431f-b234-80b72b2c59d0",
  },
  {
    id: "treasure_54",
    name: "The Freedom Hub",
    hint: "Start your morning on Young Street, Waterloo, with a delicious breakfast at the Hub, now 10% off to fuel your day.",
    offer: "10% off Breakfast Menu",
    address: "283 Young Street, Waterloo 2017",
    hours: "Monday \u2013 Friday: 7:00am \u2013 2:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.9015073073891,
      longitude: 151.20802826330944,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FThe%20Freedom%20Hub.jpg?alt=media&token=0e8f7635-b238-40b5-b122-9a782e9df172",
  },
  {
    id: "treasure_55",
    name: "Blue36 Cafe",
    hint: "Swing by Greenwood Plaza at 36 Blue Street, North Sydney, for your morning brew fix in a cozy corner spot loved by locals.",
    offer: "Buy one coffee, get one free.",
    address: "Greenwood Plaza, 36 Blue Street, North Sydney, NSW 2060",
    hours:
      "Monday \u2013 Friday: 6:00am \u2013 2:30pm\nSaturday: 7:00am \u2013 1:00pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.84088023189399,
      longitude: 151.20728961336468,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FBlue36%20Cafe.jpg?alt=media&token=b76877f5-da08-4ef0-8461-97a344e3e08f",
  },
  {
    id: "treasure_56",
    name: "La Riviera",
    hint: "Find your way to 170 Phillip Street, Sydney, for a chic European-style dining experience tucked between the city’s legal and business hubs. La Riviera is one not to be missed.",
    offer:
      "Enjoy a complimentary glass of La Riviera wine or a draft beer with the purchase of a meal (one free drink per meal).",
    address: "170 Phillip Street, Sydney",
    hours:
      "Monday \u2013 Friday: Open for lunch\nWednesday \u2013 Saturday: Open for dinner",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.868343622879955,
      longitude: 151.2114681801263,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FLa%20Riviera.jpg?alt=media&token=47a0b763-1cce-46c2-aba5-401ebb597e69",
  },
  {
    id: "treasure_57",
    name: "a'Mare",
    hint: "Treat yourself at Crown Sydney with pasta, wine, and a sweet gelato finish. This elegant Italian spot at Barangaroo is perfect for a Sunday indulgence.",
    offer:
      "Pasta Sundaes menu for $55 per person. Enjoy a glass of wine, a cozy pasta, then finish the meal with one of a'Mare\u2019s iconic house-made gelatos.",
    address: "Crown Sydney, 1 Barangaroo Avenue, Barangaroo",
    hours:
      "Thursday \u2013 Monday: Lunch from 12:00pm \u2013 2:30pm\nEvery Day: Dinner from 5:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86190632630534,
      longitude: 151.2009304703329,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2Fa'Mare.jpg?alt=media&token=9b115f65-6724-4265-b99f-0623463b2e1d",
  },
  {
    id: "treasure_58",
    name: "Hendry\u2019s Coffee",
    hint: "Start your day on Liverpool Street, Darlinghurst, with a fresh brew and enjoy 10% off your coffee fix at Hendry's.",
    offer: "Value Bundle : $15\nAny regular coffee + any toastie.",
    address: "Shop 1, 144\u2013150 Liverpool Street, Darlinghurst 2010",
    hours: "6:30am \u2013 3:00pm (every day)",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.87682024646839,
      longitude: 151.2127436785257,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FHendry%CE%93%C3%87%C3%96s%20Coffee.jpg?alt=media&token=c736ebc1-d21a-4fe7-ad58-f927469795af",
  },
  {
    id: "treasure_59",
    name: "NOMAD",
    hint: "Wander over to 16 Foster Street in Surry Hills for mezze-style lunches and an express menu, plus a dessert on the house!",
    offer:
      "Mezze-style lunches at $60pp and $90pp express menu available for lunch and dinner \u2013 dessert on us!",
    address: "16 Foster Street, Surry Hills, NSW 2010",
    hours:
      "Tuesday:\u00a05:30pm \u2013 Late\u2028Wednesday \u2013 Saturday:\u00a012:00pm \u2013 3:00pm, 5:30pm \u2013 Late",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Bookings preferred, not essential. Bookings can be made from 12:00pm to 2:30pm",
    code: "TCSSYDMARA26",
    coordinates: {
      latitude: -33.8798957095395,
      longitude: 151.2103600298687,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FNOMAD.jpg?alt=media&token=571c3f7d-ca52-4e71-83ca-ac3df4f0f3ce",
  },
  {
    id: "treasure_60",
    name: "Industry Beans Castlereagh St.",
    hint: "Fuel your post-race buzz with a cool pick-me-up. Just off Castlereagh, score two Fitzroy Iced Coffees for the price of one \u2014 perfect for sharing or doubling up!\n",
    offer: "Two-for-one Fitzroy Iced Coffees.",
    address: "8 Castlereagh Street, Sydney, NSW 2000",
    hours:
      "Friday 29th: 7:00am \u2013 3:30pm\nSaturday 30th: 8:00am \u2013 3:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Offer applies to a regular Fitzroy Iced Coffee, takeaway only. Available to redeem once per day per customer.",
    code: "TCSSYDMARA27",
    coordinates: {
      latitude: -33.86652400032291,
      longitude: 151.2101088147506,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FIndustry%20Beans%20Castlereagh%20St..jpg?alt=media&token=69ffc2a3-13d0-43d2-b16c-1227734303b4",
  },
  {
    id: "treasure_61",
    name: "Industry Beans York St.",
    hint: "Need a cool reward near Wynyard? Head to York Street and grab two Fitzroy Iced Coffees for the price of one \u2014 smooth, bold, and twice as nice.",
    offer: "Two-for-one Fitzroy Iced Coffees.",
    address: "38\u201340 York Street, Sydney, NSW 2000",
    hours:
      "Friday 29th: 7:00am \u2013 3:30pm\nSaturday 30th: 8:00am \u2013 3:30pm",
    redeem: "Must show code to staff/server to redeem",
    terms:
      "Offer applies to a regular Fitzroy Iced Coffee, takeaway only. Available to redeem once per day per customer.",
    code: "TCSSYDMARA28",
    coordinates: {
      latitude: -33.86931359010019,
      longitude: 151.2062390834864,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FIndustry%20Beans%20York%20St..jpg?alt=media&token=3f07bed9-8559-4623-951a-2eb8d9c4fa38",
  },
  {
    id: "treasure_62",
    name: "Quick Brown Fox",
    hint: "The sly one\u2019s hiding in Pyrmont! Catch the Quick Brown Fox on Union Street and enjoy 10% off your post-run fuel.",
    offer: "Free small coffee with any food purchase both dine-in or takeaway.",
    address: "22 Union Street, Pyrmont",
    hours: "7:00am \u2013 3:00pm (every day)",
    redeem: "Must show code to staff/server to redeem",
    terms: "Max 1 coffee per person / purchase, includes pastries",
    code: "TCSSYDMARA29",
    coordinates: {
      latitude: -33.86939920237085,
      longitude: 151.19470938929513,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FQuick%20%20Brown%20Fox.jpg?alt=media&token=7c2428fa-5cf6-47bd-b820-6106121b0167",
  },
  {
    id: "treasure_63",
    name: "The Glenmore",
    hint: "Climb up Cumberland Street in The Rocks and look out for the rooftop with harbour views serving marathon-day drink and schnitzel specials! You'll leave wanting more",
    offer: "$20 schnitzels + $12 pints of 4 Pines Japanese Lager.",
    address: "96 Cumberland Street, The Rocks, NSW 2000",
    hours: "Sunday- Thursday: 11am-12am \nFriday-Saturday: 11am-1am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA30",
    coordinates: {
      latitude: -33.85861522346978,
      longitude: 151.20742867399204,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FThe%20Glenmore.jpg?alt=media&token=2c5ede18-fcb2-449d-9c3a-de565bf8ac73",
  },
  {
    id: "treasure_64",
    name: "Kent St Hotel",
    hint: "Kent St on Kent St; CBD classic where beers run cold and banter runs deep.",
    offer:
      "$15 \nCarb-up meal special available exclusively to the Sydney Marathon community!",
    address: "347 Kent Street, Sydney, NSW 2000",
    hours: "10:00am \u2013 12:00am",
    redeem: "Must show code to staff/server to redeem",
    terms: NaN,
    code: "TCSSYDMARA25",
    coordinates: {
      latitude: -33.86859340448879,
      longitude: 151.2043572436242,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FKent%20St%20Hotel.png?alt=media&token=ca8c845c-ddd2-42fb-96e9-b822a62af3b9",
  },
  {
    id: "treasure_65",
    name: "The Rocks Walking Tour",
    hint: "Explore historic Harrington Street and unlock stories of The Rocks Walking Tour, grab $10 off your tour.",
    offer: " Spectator’s Special Discount: $10.00 off per person.",
    address: "28 Harrington Street, The Rocks, Sydney 2000",
    hours:
      "Daily shared public tours are at 10.30am and 1.30pm every day. Available for the whole duration of Event Week, including Event Day",
    redeem:
      "Must show code to staff/server to redeem, or enter the code when booking through the official website: https://www.rockswalkingtours.com.au/",
    terms:
      "Offer is only applicable when purchasing an adult ticket. Offer not available on any other third-party booking platforms.",
    code: "CHEER10",
    coordinates: {
      latitude: -33.859119658821044,
      longitude: 151.20811549611122,
    },
    image:
      "https://firebasestorage.googleapis.com/v0/b/sydney-marathon-2025.firebasestorage.app/o/Treasure%20Hunt%20Images%20EVENT%20WEEK%2026TH%20AUGUST%2FThe%20Rocks%20%20Walking%20Tours%20(1).png?alt=media&token=f275ac75-dcfa-46df-beeb-cec76c060670",
  },
];
